var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatSaludEHigiene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cat_salud-e-higiene",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 200,
    height: 200,
    fill: "#e8eff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-medical-10",
    d: "M126.4,66.779A42.042,42.042,0,0,1,140.46,98.511c0,22.566-17.048,40.891-38.041,40.891a35.569,35.569,0,0,1-13.578-2.686ZM56.74,119.68l-2.124,3.988c-8.076,15.042-25.991,20.2-39.978,11.519S-4.155,107.249,3.921,92.214L44.146,16.734C49.594,6.587,59.514.938,69.692,1A27.6,27.6,0,0,1,84.124,5.215C94.9,11.9,100.23,24.875,98.41,37.35a33.108,33.108,0,0,1-2.259,8.1,47.034,47.034,0,0,0-16.129,5.3L84.7,41.9c4.846-9.021,1.966-20.578-6.426-25.787S59.128,14,54.282,23.025L34.548,60.362,57.829,74.806A57.227,57.227,0,0,0,56.74,119.68Zm21.947,10.783A42.029,42.029,0,0,1,64.378,98.511c0-22.566,17.048-40.891,38.041-40.891A35.54,35.54,0,0,1,116.3,60.431Z",
    transform: "translate(30 30)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatSaludEHigiene);
export default __webpack_public_path__ + "static/media/cat_salud-e-higiene.9f70187c.svg";
export { ForwardRef as ReactComponent };